import GetDocumentPendingDownload from "../UseCase/GetDocumentPendingDownload";
import DocumentRepository from "../Repository/DocumentRepository";
import DocumentResourceRepository from "../Repository/DocumentResourceRepository";
import getDatabase from "./database";
import getDocumentDownloadFactory from "./documentDownloadFactory";

const getDocumentPendingDownload: GetDocumentPendingDownload = new GetDocumentPendingDownload(
    new DocumentRepository(getDatabase()),
    new DocumentResourceRepository(getDatabase()),
    getDocumentDownloadFactory()
);

export default function getGetDocumentPendingDownload(): GetDocumentPendingDownload {
    return getDocumentPendingDownload;
}